import request from '@/utils/request'

// 安全地从 localStorage 读取 JSON 数据
const safeGetStorageItem = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key)
    if (!item || item === 'undefined' || item === 'null') {
      return defaultValue
    }
    return JSON.parse(item)
  } catch (error) {
    console.warn(`Failed to parse localStorage item "${key}":`, error)
    return defaultValue
  }
}

const persistedToken = localStorage.getItem('token') || ''
const persistedUserInfo = safeGetStorageItem('userInfo', {})

const state = {
  token: persistedToken,
  userInfo: persistedUserInfo,
  isAuthenticated: !!persistedToken
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    localStorage.setItem('token', token)
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  SET_AUTHENTICATED(state, status) {
    state.isAuthenticated = status
  },
  CLEAR_AUTH(state) {
    state.token = ''
    state.userInfo = {}
    state.isAuthenticated = false
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }
}

const actions = {
  async login({ commit }, credentials) {
    try {
      // 调用真实的后端登录API
      const response = await request({
        url: '/auth/login',
        method: 'post',
        data: credentials
      })

      if (response.code === 200 && response.data) {
        commit('SET_TOKEN', response.data.token)
        commit('SET_USER_INFO', response.data.userInfo)
        commit('SET_AUTHENTICATED', true)
        return response
      } else {
        throw new Error(response.message || '登录失败')
      }
    } catch (error) {
      console.error('Login error:', error)
      throw error
    }
  },

  async logout({ commit }) {
    try {
      // 调用后端登出API
      await request({
        url: '/auth/logout',
        method: 'post'
      })
    } catch (error) {
      console.error('Logout API error:', error)
    } finally {
      // 无论API调用是否成功，都清除本地认证信息
      commit('CLEAR_AUTH')
    }
  },

  async getProfile({ commit }) {
    try {
      const response = await request({ url: '/auth/profile', method: 'get' })
      const userInfo = response.data
      if (userInfo && userInfo.id) {
        commit('SET_USER_INFO', userInfo)
        commit('SET_AUTHENTICATED', true)
        return { data: userInfo }
      } else {
        throw new Error('用户信息不存在')
      }
    } catch (error) {
      console.error('Get profile error:', error)
      throw error
    }
  }
}

const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  isAuthenticated: state => state.isAuthenticated
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
